import {
  ChallengePrizeFormValues,
  PrizeFormValues,
} from '../../../../../../interfaces/ChallengeFormValues';
import {
  ChallengePrizeSection,
  PrizeInfo,
} from '../../../../../../interfaces/SaveChallengeInfo';
import { challengeService } from '../../../../../../services/challengeService';

const procesPrizes = (prizes: PrizeInfo[]): PrizeFormValues[] =>
  prizes.map((prize) => ({
    title: prize.title ?? '',
    description: prize.description ?? '',
    prizeNum: prize.prizeNum,
  }));

export const transformPrizesToFormValues = (
  prizesData: ChallengePrizeSection,
): { prizes: ChallengePrizeFormValues } => {
  return {
    prizes: {
      enabled: prizesData.enabled,
      prizes: procesPrizes(prizesData.prizes ?? []),
    },
  };
};

export const getPrizesFormValue = async (
  challengeId: number,
): Promise<{ prizes: ChallengePrizeFormValues }> => {
  const prizes = await challengeService.getChallengePrizes(challengeId);
  return transformPrizesToFormValues(prizes);
};
